import { TriangleDownIcon } from "@chakra-ui/icons";
import {
  Box,
  RangeSlider,
  RangeSliderFilledTrack,
  RangeSliderThumb,
  RangeSliderTrack,
  Text,
  VStack
} from "@chakra-ui/react";
import * as React from "react";
import { BadgeCredit } from "../../badgeCredit";
import { useAppConfig } from "../../../hooks";

export interface RangeBarProps {
  walletTotale: number;
  walletBuoni: number;
  rangeValue: number[];
  setRangeValue: (rangeValue: number[]) => void;
}

const RangeBar = ({
  rangeValue,
  setRangeValue,
  walletBuoni,
  walletTotale,
}: RangeBarProps) => {
  const { ctaColor, secondaryColor, primaryColor } = useAppConfig();
  return (
    <>
      <VStack>
        <BadgeCredit credit100={walletTotale} credit51c3={walletBuoni} />
        <Text fontSize={"sm"} fontWeight="bold" color={primaryColor}>
          Fascia da: {rangeValue[0]}€ a {rangeValue[1]}€
        </Text>
      </VStack>

      <RangeSlider
        defaultValue={[rangeValue[0], rangeValue[1]]}
        min={0}
        max={1000}
        step={10}
        onChangeEnd={(val) => setRangeValue(val)}
        color={ctaColor}
      >
        <RangeSliderTrack bg={primaryColor} aria-label={"min"}>
          <RangeSliderFilledTrack bg={ctaColor} />
        </RangeSliderTrack>
        <RangeSliderThumb boxSize={6} index={0} aria-label={"max"}>
          <Box color={ctaColor} as={TriangleDownIcon} />
        </RangeSliderThumb>
        <RangeSliderThumb boxSize={6} index={1}>
          <Box color={ctaColor} as={TriangleDownIcon} />
        </RangeSliderThumb>
      </RangeSlider>
    </>
  );
};

export default RangeBar;
